import useUserStore from "store/zustand/user";
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const { token, user, hasHydrated } = useUserStore();
  if (!hasHydrated) {
    return null;
  }

  const isAuthenticated = Boolean(token);
  if (isAuthenticated) {
    // Redirect based on the user's role
    if (user?.role?.name === "super_admin") {
      return <Navigate to="/admin" replace />; // Redirect to admin if super_admin
    } else {
      return <Navigate to="/" replace />; // Redirect to home for other roles
    }
  }

  return <Outlet />;
};

export default PublicRoute;
